module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c61d0fa03b645b88b1e0e972bb11effd.png";